import React from "react";
import { connect } from "react-redux";
import { formValueSelector, reduxForm, Field } from "redux-form";
import { FormattedDate, FormattedNumber } from "react-intl";
import * as agent from "../agent";
import { required, formatDate } from "../utility";
import { CONTRACT_UPDATED } from "../constants/actionTypes";
import PickRatesInput from "./PickRatesInput";
import {
    calculateLeasingTotalSum,
    generateLeasingPayments
} from "../businessLogic";
import { NewLoanTypes, Masks } from "../constants/enums";
import {
    MaterialTextField,
    MaterialMaskedTextField,
    MaterialCheckbox
} from "./MaterialInput";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import SubmitButton from "./SubmitButton";
import MaterialSlider from "./MaterialSlider";

class editProgramForm extends React.Component {
    render() {
        const {
            contractId,
            editMode,
            isJur,
            isLT,
            isLeasing,
            onEditContract,
            sum,
            totalSum,
            inputDuration,
            inputRates = [],
            inputSum,
            inputPreferentialRepayment,
            payments = [],
            handleSubmit
        } = this.props;
        return (
            <Paper
                className="common-paper"
                style={{ marginTop: 20, marginBottom: 20 }}
            >
                <form
                    onSubmit={handleSubmit(data =>
                        onEditContract(contractId, data)
                    )}
                >
                    <Grid container justify="center" spacing={16}>
                        <Grid item className="common-form common-column">
                            <Field
                                name="creationDate"
                                component={MaterialMaskedTextField}
                                mask={Masks.date}
                                label="Дата подписания"
                            />
                            <Field
                                name="prolongationDate"
                                component={MaterialMaskedTextField}
                                mask={Masks.date}
                                label="Дата пролонгации"
                            />
                            <Field
                                name="programType"
                                disabled={isJur ? true : false}
                                validate={required}
                                select
                                component={MaterialTextField}
                                label="Программа"
                            >
                                {Object.keys(NewLoanTypes)
                                    .filter(t => t !== "NOT_SURE")
                                    .map((t, i) => (
                                        <MenuItem key={i} value={t}>
                                            {NewLoanTypes[t]}
                                        </MenuItem>
                                    ))}
                            </Field>
                            <Field
                                component={MaterialTextField}
                                name="duration"
                                validate={required}
                                select
                                label="Срок займа"
                            >
                                {isLeasing &&
                                    Array(3)
                                        .fill(0)
                                        .map((_, j) => (
                                            <MenuItem
                                                key={j}
                                                value={`${(j + 1) * 12}`}
                                            >
                                                {(j + 1) * 12} мес.
                                            </MenuItem>
                                        ))}
                                {isLT &&
                                    Array(31)
                                        .fill(0)
                                        .map((_, k) => (
                                            <MenuItem
                                                key={k}
                                                value={`${k + 1}`}
                                            >
                                                {k + 1} дн.
                                            </MenuItem>
                                        ))}
                                {!isLeasing &&
                                    !isLT &&
                                    Array(36)
                                        .fill(0)
                                        .map((_, l) => (
                                            <MenuItem
                                                key={l}
                                                value={`${l + 1}`}
                                            >
                                                {l + 1} мес.
                                            </MenuItem>
                                        ))}
                            </Field>
                            <Field
                                component={PickRatesInput}
                                name="rates"
                                validate={required}
                                duration={isLeasing ? 1 : inputDuration}
                                sum={sum}
                            />
                            <SubmitButton
                                label={editMode ? "Сохранить" : "Далее"}
                            />
                        </Grid>
                        {isLeasing &&
                        inputDuration > 0 &&
                        inputRates.length > 0 ? (
                            <Grid item className="common-form ultrawide-column">
                                <Typography variant="h5" align="center">
                                    График платежей:
                                </Typography>
                                <FormControlLabel
                                    control={
                                        <Field
                                            name="isLeasingPrepayed"
                                            component={MaterialCheckbox}
                                        />
                                    }
                                    label="Авансовый платеж"
                                />
                                {isLeasing && (
                                    <FormControlLabel
                                        control={
                                            <Field
                                                name="preferentialRepayment"
                                                component={MaterialCheckbox}
                                            />
                                        }
                                        label="Льготное погашение"
                                    />
                                )}
                                {isLeasing && inputPreferentialRepayment && (
                                    <Field
                                        component={MaterialSlider}
                                        name="preferentialPeriod"
                                        max={inputDuration - 1}
                                    />
                                )}
                                <Table padding="checkbox">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Дата платежа</TableCell>
                                            <TableCell>
                                                Сумма лизингового платежа за
                                                текущий период
                                            </TableCell>
                                            <TableCell>
                                                Размер выкупной цены в
                                                лизинговом платеже
                                            </TableCell>
                                            <TableCell>
                                                Сумма досрочного выкупа ТС, без
                                                учета очередного лизингового
                                                платежа
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {payments.map(
                                            (
                                                {
                                                    paymentDate,
                                                    paymentTotal,
                                                    paymentCar,
                                                    paymentBuyout
                                                },
                                                i
                                            ) => (
                                                <TableRow key={i}>
                                                    <TableCell>
                                                        <FormattedDate
                                                            value={paymentDate}
                                                            day="numeric"
                                                            month="numeric"
                                                            year="numeric"
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <FormattedNumber
                                                            value={paymentTotal}
                                                            style={`currency`}
                                                            currency="RUB"
                                                            minimumFractionDigits={
                                                                0
                                                            }
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <FormattedNumber
                                                            value={paymentCar}
                                                            style={`currency`}
                                                            currency="RUB"
                                                            minimumFractionDigits={
                                                                0
                                                            }
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <FormattedNumber
                                                            value={
                                                                paymentBuyout
                                                            }
                                                            style={`currency`}
                                                            currency="RUB"
                                                            minimumFractionDigits={
                                                                0
                                                            }
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        )}
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell>Итого: </TableCell>
                                            <TableCell>
                                                <FormattedNumber
                                                    value={totalSum}
                                                    style={`currency`}
                                                    currency="RUB"
                                                    minimumFractionDigits={0}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <FormattedNumber
                                                    value={inputSum}
                                                    style={`currency`}
                                                    currency="RUB"
                                                    minimumFractionDigits={0}
                                                />
                                            </TableCell>
                                            <TableCell>&nbsp;</TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </Grid>
                        ) : (
                            <Grid item className="common-form common-column">
                                <Typography paragraph>
                                    Введите процентную ставку и срок займа
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </form>
            </Paper>
        );
    }
}

const EditProgramForm = connect(
    (state, props) => {
        const { programDetails = {}, creationDate, prolongationDate } = props;
        const {
            rates,
            duration,
            programType,
            sum,
            preferentialRepayment,
            preferentialPeriod,
            isLeasingPrepayed
        } = programDetails;
        const pT = formValueSelector("edit-contract-form")(
            state,
            "programType"
        );
        const inputIsLeasingPrepayed = formValueSelector("edit-contract-form")(
            state,
            "isLeasingPrepayed"
        );
        const inputPreferentialRepayment = formValueSelector(
            "edit-contract-form"
        )(state, "preferentialRepayment");
        const inputPreferentialPeriod = +formValueSelector(
            "edit-contract-form"
        )(state, "preferentialPeriod");
        const inputDuration = formValueSelector("edit-contract-form")(
            state,
            "duration"
        );
        const inputRates = formValueSelector("edit-contract-form")(
            state,
            "rates"
        );
        const inputCreationDate = formValueSelector("edit-contract-form")(
            state,
            "creationDate"
        );
        const iCD = inputCreationDate ? inputCreationDate.split(".") : "";
        const date = inputCreationDate
            ? new Date(iCD[2], iCD[1] - 1, iCD[0])
            : new Date();
        const d = +inputDuration || duration;
        const leasingRate = +(inputRates || rates)[0];

        const totalSum = calculateLeasingTotalSum(sum, d, leasingRate);

        const payments = generateLeasingPayments({
            date,
            duration: d,
            leasingRate,
            sum,
            preferentialPeriod: inputPreferentialPeriod,
            isLeasingPrepayed: inputIsLeasingPrepayed,
            isPreferentialRepayment: inputPreferentialRepayment
        });

        return {
            isLT: pT === "HOLD_LT",
            isLeasing: pT === "PTS_LEASING",
            sum: sum,
            payments,
            totalSum,
            inputSum: sum,
            inputDuration,
            inputIsLeasingPrepayed,
            inputPreferentialRepayment,
            inputRates,
            initialValues: {
                creationDate: formatDate(new Date(creationDate)),
                prolongationDate: formatDate(new Date(prolongationDate)),
                rates,
                preferentialRepayment,
                preferentialPeriod,
                isLeasingPrepayed,
                duration: String(duration),
                programType
            }
        };
    },
    dispatch => ({
        onEditContract: (contractId, data) =>
            agent.Contract.edit(contractId, data)
                .then(contract =>
                    dispatch({ type: CONTRACT_UPDATED, payload: contract })
                )
                .then(() => alert("Изменения сохранены"))
    })
)(
    reduxForm({
        form: "edit-contract-form",
        enableReinitialize: true
    })(editProgramForm)
);

export default EditProgramForm;



// WEBPACK FOOTER //
// ./src/components/EditProgramForm.js